<template>
  <Authenticated>
    <div class="actions">
      <h2>Settings for {{ site }}</h2>
    </div>
    <div class="payment_options" v-if="site">
      <form @submit.prevent>
        <h4>Display Theme</h4>
        <Theme />
        <div v-if="webAvailable">
          <h4>Website Controls for {{ site }}</h4>
          <ul class="grid wrapper">
            <li class="modifierBox">
              <p>Website</p>
              <ToggleSwitch onLabel="Open" offLabel="Closed" :modelValue="$hours.isOpenNow()" modelName="openClose" @update:modelValue="handleWebsite($event)" />
            </li>
            <li v-if="$hours.hours && 'unscheduled' in $hours.hours" class="hours-li" @click.stop.prevent="revertHours">
              <button class="hours-btn">
                <font-awesome-icon icon="fa-rotate-left" /> <br />
                <!-- <p>Operating hours are unscheduled</p> -->
                <p>Revert to Operating Hours</p>
              </button>
            </li>
            <!-- what gaurd should this have on it? -->
            <li class="modifierBox" > 
              <p>Delivering</p>
              <ToggleSwitch
                onLabel="On"
                offLabel="Off"
                :modelValue="siteSettings.delivery_settings"
                modelName="openDelivery"
                @update:modelValue="saveSetting('delivery_settings', $event)" />
            </li>
            <li class="hours-li">
              <button @click="openOperatingHours = !openOperatingHours" class="hours-btn"><font-awesome-icon icon="fa-plus" /> <br />Manage Operating Hours</button>
            </li>
            <OperatingHours @closeModal="openOperatingHours = !openOperatingHours" :currentSite="site" :openModal="openOperatingHours" />
          </ul>
        </div>

        <h4>
          Checkout Options (Site Wide)
          <span v-if="save_btn_text !== 'Save'" :class="save_btn_text === 'Saved' ? 'status-saved' : 'status-saving'">{{ save_btn_text }}</span>
        </h4>
        <ul class="grid wrapper">
          <li class="modifierBox">
            <p>Require order name?</p>
            <ToggleSwitch onLabel="On" offLabel="Off" :modelValue="siteSettings.nameRequired" modelName="nameRequired" @update:modelValue="saveSetting('nameRequired', $event)" />
          </li>
          <li class="modifierBox">
            <p>Allow order comments?</p>
            <ToggleSwitch
              onLabel="On"
              offLabel="Off"
              :modelValue="siteSettings.notesRequired"
              modelName="notesRequired"
              @update:modelValue="saveSetting('notesRequired', $event)" />
          </li>
          <li class="modifierBox">
            <p>Allow Images?</p>
            <ToggleSwitch
              onLabel="On"
              offLabel="Off"
              :modelValue="siteSettings.imagesRequired"
              modelName="imagesRequired"
              @update:modelValue="saveSetting('imagesRequired', $event)" />
          </li>
          <li class="modifierBox">
            <p>Future Orders?</p>
            <ToggleSwitch onLabel="On" offLabel="Off" :modelValue="siteSettings.futurePickup" modelName="futurePickup" @update:modelValue="saveSetting('futurePickup', $event)" />
          </li>
          <li class="modifierBox">
            <p>Custom Price Products?</p>
            <ToggleSwitch onLabel="On" offLabel="Off" :modelValue="siteSettings.customPrice" modelName="customPrice" @update:modelValue="saveSetting('customPrice', $event)" />
          </li>
          <li class="modifierBox">
            <p>Track Allergens?</p>
            <ToggleSwitch onLabel="On" offLabel="Off" :modelValue="siteSettings.trackAllergens" modelName="trackAllergens" @update:modelValue="saveSetting('trackAllergens', $event)" />
          </li>
        </ul>

        <h4>Companion</h4>
        <ul class="grid wrapper">
          <button class="action-colour" @click="showCompanionModal(station)">Open Companion Modal</button>
        </ul>
        <h4>
          Payment Options (Site Wide)
          <span v-if="save_btn_text !== 'Save'" :class="save_btn_text === 'Saved' ? 'status-saved' : 'status-saving'">{{ save_btn_text }}</span>
        </h4>
        <ul class="grid wrapper">
          <li class="modifierBox">
            <p>Allow EFTPOS?</p>
            <ToggleSwitch onLabel="On" offLabel="Off" :modelValue="siteSettings.eftpos_pay" modelName="eftpos_pay" @update:modelValue="saveSetting('eftpos_pay', $event)" />
          </li>
          <li class="modifierBox">
            <p>Allow Post Pay?</p>
            <ToggleSwitch onLabel="On" offLabel="Off" :modelValue="siteSettings.post_pay" modelName="post_pay" @update:modelValue="saveSetting('post_pay', $event)" />
          </li>
          <li class="modifierBox">
            <p>Allow Cash?</p>
            <ToggleSwitch onLabel="On" offLabel="Off" :modelValue="siteSettings.cash_pay" modelName="cash_pay" @update:modelValue="saveSetting('cash_pay', $event)" />
          </li>
          <li class="modifierBox">
            <p>Allow Refunds?</p>
            <ToggleSwitch
              onLabel="On"
              offLabel="Off"
              :modelValue="siteSettings.refund_allowed"
              modelName="refund_allowed"
              @update:modelValue="saveSetting('refund_allowed', $event)" />
          </li>
          <li class="modifierBox">
            <p>Surcharge?</p>
            <ToggleSwitch onLabel="On" offLabel="Off" :modelValue="siteSettings.surcharge" modelName="surcharge" @update:modelValue="saveSetting('surcharge', $event)" />
          </li>
          <li class="modifierBox">
            <p>Allow cash out?</p>
            <ToggleSwitch onLabel="On" offLabel="Off" :modelValue="siteSettings.cash_out" modelName="cash_out" @update:modelValue="saveSetting('cash_out', $event)" />
          </li>
          <li class="modifierBox">
            <p>Accounts?</p>
            <ToggleSwitch onLabel="On" offLabel="Off" :modelValue="siteSettings.accounts" modelName="accounts" @update:modelValue="saveSetting('accounts', $event)" />
          </li>
          <li class="modifierBox">
            <p>Vouchers?</p>
            <ToggleSwitch onLabel="On" offLabel="Off" :modelValue="siteSettings.vouchers" modelName="vouchers" @update:modelValue="saveSetting('vouchers', $event)" />
          </li>
          <li class="modifierBox">
            <p>Centrapay?</p>
            <ToggleSwitch onLabel="On" offLabel="Off" :modelValue="siteSettings.centrapay" modelName="centrapay" @update:modelValue="saveSetting('centrapay', $event)" />
          </li>
          <li class="modifierBox">
            <p>Stripe?</p>
            <ToggleSwitch onLabel="On" offLabel="Off" :modelValue="siteSettings.stripe" modelName="stripe" @update:modelValue="saveSetting('stripe', $event)" />
          </li>
        </ul>
        <Discounts :channel="channel" />

        <h4>Delivery Options:</h4>
        <ul class="grid wrapper">
          <li class="modifierBox" v-for="(option, idx) in siteSettings.delivery_options" :key="idx">
            <h3 class="del-option">{{ option }}</h3>
            <span @click.stop.prevent="removeDeliveryOption(idx)"><font-awesome-icon icon="fa-xmark" /></span>
          </li>
          <div class="modifierBox">
            <select name="delivery" class="dropdown" v-model="newDelivery">
              <option value="" selected>Select a delivery option</option>
              <option :value="'takeaway'">takeaway</option>
              <option :value="'dine-in'">dine-in</option>
            </select>
            <button @click.stop.prevent="addDeliveryOption" class="btn action-colour">Add delivery option</button>
          </div>
        </ul>

        <h4>
          Printers:
          <button @click.stop.prevent="savePrinter" class="save-btn action-colour">Save Printer</button>
        </h4>
        <ul class="printer-section">
          <div class="find-printer">
            <button @click.stop.prevent="searchForPrinter" class="btn">Find Printers</button>
            <p v-if="labelError.error" class="red">Please Select a label size to save printer.</p>
          </div>
          <div v-if="printerFound" class="printer-list">
            <select @change="newPrinter($event)" name="printers" id="" class="dropdown">
              <option value="" selected>Select a Printer</option>
              <option :value="p" v-for="p in printers" :key="p">Model: {{ p[1] }} - IP: {{ p[0] }}</option>
            </select>
          </div>
          <div v-if="printer" class="selected-printer">
            <div class="cur-printer">
              <p>Selected Printer:</p>
              <p class="blue">Model: {{ printer.model }}</p>
              <p class="blue">IP: {{ printer.ip }}</p>
              <p v-if="printer.label != 'Select...'" class="blue">Label: {{ printer.label }}</p>
            </div>
            <div class="label">
              <p>Change Label Size</p>
              <select v-if="isAndroid" id="labels" class="dropdown">
                <option disabled selected>Select...</option>
                <option v-for="label in getLabels" :value="label" :key="label">
                  {{ label }}
                </option>
              </select>
              <select v-if="isIOS" id="labels" class="dropdown">
                <option disabled selected>Select...</option>
                <option v-for="label in labels" :value="label" :key="label">
                  {{ label }}
                </option>
              </select>
            </div>
          </div>
        </ul>
        <h4>
          Station Settings:
          <span v-if="save_pos_btn_text !== 'Save'" :class="save_pos_btn_text === 'Saved' ? 'status-saved' : 'status-saving'">{{ save_pos_btn_text }}</span>
        </h4>
        <ul class="grid wrapper eftpos">
          <li class="modifierBox">
            <button class="action-colour" @click.stop.prevent="showPaymentTerminalModal = true">Payment Terminal Settings</button>
          </li>
          <li class="modifierBox">
            <p class="del-option">Use Modals</p>
            <sub class="blue t-align-center">Turn this on to use modal dialogs for certain actions.</sub>
            <ToggleSwitch :modelValue="useModals" modelName="use_modals" @update:modelValue="handleModalSettings('use_modals', $event)" />
          </li>
          <li class="modifierBox">
            <p>Cash up</p>
            <sub class="blue t-align-center">This will enable cash up for this station.</sub>
            <ToggleSwitch :modelValue="localSettings[0].float" modelName="float" @update:modelValue="handleModalSettings('float', $event)" />
          </li>
        </ul>
      </form>
    </div>
    <div v-if="loadingPrinters" class="loading">
      <LoadingSpinner :spinnerMessage="'Searching for Printers...'" />
    </div>
    <PaymentTerminalModal
      :stripeReaders="stripeReaders"
      :open="showPaymentTerminalModal"
      :errorMsg="paymentModalErrorMsg"
      @close="showPaymentTerminalModal = false"
      @eftposNZConnect="handleEftposNZ"
      @stripe-connect="connectReader"
      @set-as-terminal-provider="setTerminalProvider"
      @select-providers="selectProviders"
      @remove-terminal-provider="removeTerminalProvider"
      @smartpay-connect="connectSmartPay" />
    <CompanionModal :open="openCompanionModal" :station="POSStation" />
  </Authenticated>
</template>

<script>
import Discounts from "@/components/Discounts/Discounts.vue";
import Authenticated from "@/components/_layouts/Authenticated";
import { mapActions, mapGetters } from "vuex";
import { Theme, LoadingSpinner, CodeLogIn, ToggleSwitch, PaymentTerminalModal, CompanionModal, OperatingHours } from "@monolith/components";
// import OperatingHoursModal from "./OperatingHoursModal.vue";
import holidays2024 from "../../../public/holidays.json";
import holidays2025 from "../../../public/holidays2025.json";
import SmartPayHelper from "@/components/_mixins/smartPayHelper.js";
//import { getCurrentInstance } from 'vue';
//const { proxy } = getCurrentInstance();
import { hours } from "@monolith/helpers";

export default {
  name: "Settings",
  components: {
    Authenticated,
    Discounts,
    ToggleSwitch,
    Theme,
    LoadingSpinner,
    CodeLogIn,
    PaymentTerminalModal,
    CompanionModal,
    OperatingHours,
  },
  mixins: [SmartPayHelper],
  data() {
    return {
      // float: "float" in JSON.parse(localStorage.getItem("localSettings"))[0] ? JSON.parse(localStorage.getItem("localSettings"))[0].float : false,
      company: window.localStorage.getItem("company"),
      currentFloat: null,
      station: window.localStorage.getItem("station"),
      site: window.localStorage.getItem("site"),
      eftposIP: null,
      eftposPort: null,
      save_btn_text: "Save",
      save_pos_btn_text: "Save",
      darkMode: false,
      lightMode: false,
      osDefault: true,
      selectedRegion: "",
      openClose: false,
      openOperatingHours: false,
      thisYear: new Date(Date.now()).getFullYear(),
      nextYear: new Date(Date.now()).getFullYear() + 1,
      currentYear: new Date(Date.now()).getFullYear(),
      holidays: [],
      holidayFinal: [],
      weekFinal: [],
      daysOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      newDelivery: "",
      printers: [],
      printerSelected: false,
      printerFound: false,
      printerNotFound: false,
      printer: {},
      labelSize: "",
      printerDone: true,
      loadingPrinters: false,
      labelError: {
        note: "",
        error: false,
      },
      labels: [],
      stripeReaders: [],
      selectedReader: {},
      showPaymentTerminalModal: false,
      openCompanionModal: false,
      POSStation: null,
      useModals: false,
      paymentModalErrorMsg: "",
    };
  },
  computed: {
    ...mapGetters({
      getClosed: "getClosed",
      siteSettings: "siteSettings",
      localSettings: "localSettings",
      eftposSettings: "eftposSettings",
      getWebsites: "getWebsites",
      terminalProviders: "terminalProviders",
      getHours: "getHours",
    }),

    holidayObj() {
      return this.natHolidays.map((day) => {
        const dayOpen = {
          open: false,
          openTime: "",
          closeTime: "",
          name: "",
          date: "",
          regional: false,
        };
        dayOpen.name = day.HolidayName;
        dayOpen.date = day.ActualDate;
        dayOpen.regional = day.Regional;
        return dayOpen;
      });
    },

    weekObj() {
      return this.daysOfWeek.map((day) => {
        const dayOpen = { open: false, openTime: "", closeTime: "", name: "" };
        dayOpen.name = day;
        return dayOpen;
      });
    },

    natHolidays() {
      const nats = this.holidays.filter((hol) => hol.Type == "National");
      nats.push(new Proxy({ HolidayName: "", ActualDate: "", Regional: true }, {}));
      return nats;
    },

    getRegionNames() {
      return this.getRegions.map((holiday) => {
        let region = holiday.HolidayName.split(" ").splice(0, holiday.HolidayName.split(" ").length - 2);
        return region.join(" ");
      });
    },

    getRegions() {
      return this.holidays.filter((hol) => hol.Type == "Regional");
    },

    getCurrentRegion() {
      return "hours" in this.siteSettings ? this.siteSettings.hours["holiday" + this.thisYear].filter((day) => day.regional) : false;
    },

    getLabels() {
      if (window.Android && window.Android.getLabels) {
        return JSON.parse(window.Android.getLabels());
        // } else if (window.webkit && window.webkit.messageHandlers) {
        // let labels = window.webkit.messageHandlers.brotherHandler.postMessage({ action: "getLabels" });
        // return JSON.parse(window.webkit.messageHandlers.brotherHandler.postMessage({ action: "getLabels" }));
        // return labels;
      } else {
        return [];
      }
    },

    webAvailable() {
      let web = false;
      if (this.getWebsites !== undefined) {
        this.getWebsites.map((site) => {
          if (site["site"] == this.site) {
            web = true;
          }
        });
      }
      return web;
    },
    isAndroid() {
      return window.Android;
      //return /Android/i.test(navigator.userAgent);
    },
    isIOS() {
      return window.webkit && window.webkit.messageHandlers;
    },
  },
  async mounted() {
    this.$store.commit("currPage", "settings");
    this.setYear(this.thisYear);
    this.holidayFinal = "hours" in this.siteSettings ? this.siteSettings.hours["holiday" + this.thisYear] : this.holidayObj;
    this.weekFinal = "hours" in this.siteSettings ? this.siteSettings.hours.week : this.weekObj;
    let result = JSON.parse(window.localStorage.getItem("printer"));
    if (result != null) {
      this.printer = result;
      this.printerSelected = true;
    }
    this.$hours.popHours(this.getHours);
  },

  beforeMount() {
    window["Beamy"] = {
      components: this,
      stripeTerminals: (msg) => this.stripeReaders.push(...JSON.parse(msg)),
      printerSearchResult: (printers) => this.listPrinters(printers),
      IOSPrinterLabels: (labels) => {
        this.labels = labels;
      },
      printerDone: () => this.printerFinished(),
    };
  },

  methods: {
    ...mapActions(["updateSettings"]),

    selectProviders() {
      let settings = this.localSettings;
      settings[0].terminal_providers = this.terminalProviders;
      this.paymentModalErrorMsg = "";
      this.saveEFTPOSSettings(true);
    },

    removeTerminalProvider(provider) {
      let settings = this.localSettings;
      if (provider === "smartpay") {
        delete settings[0].smartpay_terminal;
        this.handleActiveTerminalChange();
      } else if (provider === "eftpos_nz") {
        this.handleActiveTerminalChange();
        delete settings[0].eftpos;
      } else if (provider === "stripe") {
        this.handleActiveTerminalChange();
        // remove stripe reader info if needed
      }
      this.saveEFTPOSSettings(true);
    },

    handleActiveTerminalChange() {
      if (this.terminalProviders.length == 1) {
        this.setTerminalProvider(this.terminalProviders[0]);
      } else if (this.terminalProviders.length == 0) {
        this.setTerminalProvider(null);
        this.paymentModalErrorMsg = "Please select at least one terminal provider if you want to process card payments.";
      } else {
        this.setTerminalProvider(this.terminalProviders[0]);
      }
      this.saveEFTPOSSettings(true);
    },

    handleModalSettings(key, value) {
      let settings = this.localSettings;
      settings[0][key] = value;
      this.saveEFTPOSSettings();
    },

    setTerminalProvider(provider) {
      let settings = this.localSettings;
      settings[0].active_terminal = provider;
      this.saveEFTPOSSettings(true);
    },

    handleEftposNZ(eftposSettings) {
      let settings = this.localSettings;
      settings[0]["eftpos"] = {
        ip: eftposSettings.ip,
        port: eftposSettings.port,
      };
      this.saveEFTPOSSettings();
    },

    async connectSmartPay({ pairingCode, registerName }) {
      let r = await this.initialisePairing(pairingCode, registerName);
      let settings = this.localSettings;
      if (r.data.result === "success") {
        settings[0]["smartpay_terminal"] = {
          POSRegisterID: r.POSRegisterID,
          POSRegisterName: r.POSRegisterName,
        };
        this.$notify({
          text: "SmartPay: Successfully paired with terminal",
        });
        this.saveEFTPOSSettings();
      } else {
        this.$notify({
          text: "SmartPay: Error pairing with terminal",
          type: "error",
        });
      }
    },

    saveSetting(key, value) {
      this.save_btn_text = "Saving";
      this.channel
        .push("company:site:setting", { key, value })
        .receive("ok", () => {
          this.save_btn_text = "Saved";
          this.siteSettings[key] = value;

          setTimeout(() => {
            this.save_btn_text = "Save";
          }, 2000);
        })
        .receive("error", () => {
          this.save_btn_text = "Error";
          setTimeout(() => {
            this.save_btn_text = "Save";
          }, 3000);
        });
    },

    handleWebsite(value) {
      this.$notify({
        text: " You have overriden operating hours for today",
        type: "warning",
        duration: 5000, 
      });
      hours.updateUnscheduled(value);
      this.channel.push("company:site:setting", { key: "hours", value: hours.hours });
      // this.channel.push("company:site:close", { site: this.site, key: "hours", value: hours.hours });
    },

    revertHours() {
      hours.removeUnscheduled();
      this.channel.push("company:site:setting", { key: "hours", value: hours.hours });
    },

    showCompanionModal() {
      let stations = JSON.parse(window.localStorage.getItem("stations"));
      stations.forEach((station) => {
        if (station.name == this.station && station.site == this.site) {
          this.POSStation = station;
        }
      });
      this.openCompanionModal = !this.openCompanionModal;
    },

    scanForReaders() {
      if (window.Android && typeof window.Android.scanForReaders === "function") {
        window.Android.scanForReaders();
      } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.stripeHandler) {
        window.webkit.messageHandlers.stripeHandler.postMessage({
          action: "discoverReaders",
          additionalData: { note: "This is a test message" },
        });
      } else {
        console.log("Android and IOS are not available");
      }
    },

    connectReader() {
      if (window.Android && window.Android.connectReader) {
        window.Android.connectReader();
      } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.stripeHandler) {
        let readerData = {
          deviceType: this.selectedReader.deviceType,
          serialNumber: this.selectedReader.serialNumber,
        };
        window.webkit.messageHandlers.stripeHandler.postMessage({
          action: "connectReader",
          additionalData: readerData,
        });
      } else {
        console.log("Android interface not available");
      }
    },

    searchForPrinter() {
      if ("Android" in window) {
        this.loadingPrinters = true;
        window.Android.searchForPrinter();
      } else if (window.webkit && window.webkit.messageHandlers) {
        this.loadingPrinters = true;
        window.webkit.messageHandlers.brotherHandler.postMessage({
          action: "searchForPrinter",
        });
      } else {
        this.loadingPrinters = false;
        this.printerNotFound = true;
      }
    },

    listPrinters(printers) {
      if (printers == []) {
        this.printerNotFound = true;
      } else {
        this.printerFound = true;
        this.printers = printers;
        this.loadingPrinters = false;
      }
    },

    printerFinished() {
      this.printerDone = true;
    },

    savePrinter() {
      let label = document.getElementById("labels");
      if (label.value == "Select...") {
        this.labelError.error = true;
        this.labelError.not = "select a label size";
        return;
      } else {
        this.printer.label = label.value;
        window.localStorage.setItem("printer", JSON.stringify(this.printer));
        this.printers = [];
        this.labelError.error = false;
      }
    },

    newPrinter(event) {
      let p = event.target.value.split(",");
      this.printer.ip = p[0];
      this.printer.model = p[1].replace("-", "_");
      this.printer.label = "";
      this.printerSelected = true;
    },

    saveFloat() {
      //let setting = JSON.parse(localStorage.getItem("localSettings"));
      //setting[0].float = this.float;
      //localStorage.setItem("localSettings", JSON.stringify(setting));
    },

    addDeliveryOption() {
      if (this.newDelivery) {
        this.siteSettings.delivery_options.push(this.newDelivery);
        this.newDelivery = "";
        this.saveSiteSettings();
      }
    },

    removeDeliveryOption(idx) {
      this.siteSettings.delivery_options.splice(idx, 1);
      this.saveSiteSettings();
    },

    saveEFTPOSSettings(keepModalOpen = false) {
      let stations = JSON.parse(window.localStorage.getItem("stations"));
      localStorage.setItem("localSettings", JSON.stringify(this.localSettings));
      let newStations = stations.map((station) => {
        if (station.site == this.localSettings[0].site && station.name == this.localSettings[0].name) {
          return JSON.parse(localStorage.getItem("localSettings"))[0];
        } else {
          return station;
        }
      });
      if (!keepModalOpen) {
        this.showPaymentTerminalModal = false;
      }
      this.saveStationSettings(newStations);
    },

    saveStationSettings(stations) {
      this.save_pos_btn_text = "Saving";
      this.channel
        .push("company:pos_station:update", stations)
        .receive("ok", () => {
          this.save_pos_btn_text = "Saved";
          setTimeout(() => {
            this.save_pos_btn_text = "Save";
          }, 2000);
        })
        .receive("error", () => {
          this.save_pos_btn_text = "Error";
          setTimeout(() => {
            this.save_pos_btn_text = "Save";
          }, 3000);
        });
    },

    saveSiteSettings() {
      this.save_btn_text = "Saving";
      this.channel
        .push("company:site:update", this.siteSettings)
        .receive("ok", () => {
          this.save_btn_text = "Saved";
          setTimeout(() => {
            this.save_btn_text = "Save";
          }, 2000);
        })
        .receive("error", () => {
          this.save_btn_text = "Error";
          setTimeout(() => {
            this.save_btn_text = "Save";
          }, 3000);
        });
    },

    openCloseSite() {
      this.channel.push("company:site:close", { status: this.getClosed });
    },

    setYear(year) {
      if (this.thisYear.toString() == year.toString()) {
        this.holidays = holidays2024;
      } else {
        this.holidays = holidays2025;
      }
      this.currentYear = year;
    },

    saveOpeningHours() {
      this.siteSettings.hours = {
        holiday: this.holidayFinal,
        week: this.weekFinal,
      };
      this.updateSettings([this.siteSettings, this.localSettings]);
      this.saveSiteSettings();
    },

    logoutCompanion() {
      this.channel.push("companion:logout", this.station);
    },
  },
  watch: {
    localSettings: {
      handler() {
        this.useModals = this.localSettings[0].use_modals;
      },
      deep: true,
    },

    // terminalProviders: {
    //   handler() {
    //     this.localSettings[0].selected_terminal_providers = this.terminalProviders;
    //     this.saveEFTPOSSettings(true);
    //   },
    //   deep: true,
    // },

    selectedRegion() {
      let matchedRegion = this.getRegions.filter((holiday) => holiday.HolidayName.includes(this.selectedRegion));
      this.holidayFinal.forEach((h) => {
        if ("regional" in h && h.regional) {
          h.name = matchedRegion[0].HolidayName;
          h.date = matchedRegion[0].ActualDate;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.eftpos {
  grid-column: 1 / 3;
}

h4 {
  margin-top: 0;
  margin-bottom: 0;
}

.blue {
  color: var(--action-colour);
}

.t-align-center {
  text-align: center;
}

.red {
  color: red;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  background: var(--opacity-background);
}

li {
  p {
    margin: 0.5rem;
  }
  .del-option {
    text-transform: capitalize;
  }
}

.printer-section {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 1rem;
  padding: 1rem;
  background-color: var(--secondary-colour);
  border-radius: 0.5rem;
  .find-printer {
    display: flex;
    flex-direction: column;
    p {
      width: 10rem;
      margin: 0.5rem;
      text-align: center;
    }
  }
  .selected-printer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 1rem;
    margin: 0.5rem;
    background-color: var(--primary-colour);
    border-radius: 0.5rem;
    .cur-printer,
    .label {
      p {
        margin: 0.25rem;
      }
    }
  }
  .printer-list {
    display: inherit;
    .printer {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      padding: 1rem;
      margin: 0.5rem;
      background-color: var(--primary-colour);
      border-radius: 0.5rem;
      cursor: pointer;
      transition: ease-in-out 500ms;
    }
  }
  .btn {
    height: 3rem;
    width: 10rem;
    background-color: var(--action-colour);
    color: var(--secondary-text-colour);
    border: none;
    border-radius: 0.25rem;
    padding: 1rem;
    margin: 0.5rem;
    cursor: pointer;
    transition: ease-in-out 500ms;
  }
}

.float {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.hours-btn {
  background-color: var(--secondary-colour);
  color: var(--banner-colour);
  max-width: 100%;
  min-width: calc(100% - 1rem);
  border: none;
  border-radius: 5px;
  padding: 2.5rem;
  margin: 0.5rem;
  cursor: pointer;
  transition: ease-in-out 500ms;
  border: 3px solid var(--primary-colour);
  box-shadow: none;
  p {
    // font-size: 0.75rem;
    margin: 0;
  }
  &:hover {
    background-color: var(--hover-colour);
    color: var(--text-colour);
  }
}

.save-printer {
  background-color: var(--action-colour);
  color: var(--secondary-text-colour);
  border: none;
  border-radius: 0.5rem;
  padding: 1rem;
  margin: 0.5rem;
  cursor: pointer;
  transition: ease-in-out 500ms;
  border: 3px solid var(--banner-colour);
}

form {
  label {
    display: contents;
  }
}
.toggle {
  --toggle-width: 12rem;
  --toggle-border-off: black;
  --toggle-border-on: black;
  --toggle-bg-on: var(--action-colour);
  --toggle-border: 2px;
  --toggle-height: 48px;
  --toggle-font-size: 1rem;
  outline-color: green;
  outline: 0;
  border-color: var(--action-colour);
  border-left-width: 1px;
  border-right-width: 1px;
}
.dropdown {
  width: 100%;
  border: 1px solid var(--action-colour);
  border-radius: 0.5rem;
  padding: 0.5rem;
  background-color: var(--secondary-colour);
  color: var(--text-colour);
  font-size: 1rem;
  margin: 0.5rem;
}

.tri-toggle {
  margin: 1rem;
  max-width: 7rem;
  // border: 2px solid var(--text-colour);
  .radio {
    background-color: var(--action-colour) !important;
  }
}

.timePicker {
  input {
    width: 50%;
    border: 1px solid var(--action-colour);
    border-radius: 0.5rem;
    padding: 0.5rem;
    background-color: var(--secondary-colour);
    color: var(--text-colour);
    font-size: 1rem;
    margin: 0.5rem;
  }
}
.details {
  align-items: flex-start;
  p {
    margin: 3px;
    text-align: left;
  }
}

.code-login ::v-deep(*) {
  background-color: var(--action-colour) !important;
  margin: 1rem;
}

.status-saved {
  color: #4caf50;
  font-size: 0.9rem;
  margin-left: 0.5rem;
}

.status-saving {
  color: #ff9800;
  font-size: 0.9rem;
  margin-left: 0.5rem;
}

@media only screen and (orientation: portrait) {
  .toggle {
    --toggle-width: 7rem;
  }
  .hours-li {
    .hours-btn {
      padding: 1rem;
      margin-bottom: 0 !important;
    }
  }
}
</style>
